import { gql } from "@apollo/client";

export default gql`
  mutation SaveGovernmentSharing($governmentSlug: String!, $sharing: GovernmentSharingInput, $enableSharing: Boolean!) {
    saveGovernmentSharing(governmentSlug: $governmentSlug, enableSharing: $enableSharing, sharing: $sharing) {
      _id
      enableSharing
      sharing {
        team
        productStack
        projects
        stories
        resources
      }
    }
  }
`;
